import React, { useState, useEffect } from 'react';
import moment from 'moment';
import './HospitalScheduleCommonPopup.css';
import './HospitalScheduleModifySubPopup.css';

function HospitalScheduleModifySubPopup ({ isOpen, onClose, onDelete, onSave, selectedRow, scheduleId, doctorId, scheduleDate, doctorName, workStatus })  {
  const [selectedWorkStatus, setSelectedWorkStatus] = useState(0);

  useEffect(() => {
    if(workStatus === '당직'){
      setSelectedWorkStatus(0);
    } else if(workStatus === '휴진') {
      setSelectedWorkStatus(1);
    } else if(workStatus === '야간') {
      setSelectedWorkStatus(2);
    }
  },[workStatus]);

  const isPastDate = moment(scheduleDate).isBefore(moment(), 'day');

  const modifyDocSched = () => {
    const mbj = {
      id: scheduleId,
      stdMonth: scheduleDate.match(/^\d{4}-\d{2}/)[0],
      hospitalId: selectedRow.id,
      doctorId: doctorId,
      doctorName: doctorName,
      type: selectedWorkStatus,
      schDt: scheduleDate
    }
    onSave(mbj);
  } 

  const deleteDocSched = () => {
    const obj = {
      scheduleId: scheduleId,
      scheduleDate: scheduleDate,
    }
    onDelete(obj);
  }

  return (
    isOpen && (
      <div className="manage-popup">
        <div className="manage-popup-content-sv">
            <div className="manage-popup-header">
              <label>{doctorName} 당직/휴진 현황</label>
            </div>
            <div className="manage-popup-body">
              <span style={{fontWeight: 600}}>근무일: {scheduleDate}</span>
                <div className="manage-time-select">
                  <label>근무유형 선택</label>
                  <select value={selectedWorkStatus} onChange={(e) => setSelectedWorkStatus(e.target.value)}>
                      <option value=""> 근무 유형 </option>
                      <option value="0">당직</option>
                      <option value="1">휴진</option>
                      <option value="2">야간</option>
                  </select>
                </div>
            </div>
            <div className="manage-popup-footer">
                {!isPastDate  && (<button className="book-button" onClick={modifyDocSched}>수정</button>)}
                {!isPastDate  && (<button style={{backgroundColor: 'red'}} onClick={deleteDocSched}>삭제</button>)}
                <button onClick={onClose}>닫기</button>
            </div>
        </div>
      </div>
    )
  );
};

export default HospitalScheduleModifySubPopup;
